export const parseLoadListFromManual = loadList => {
    return loadList.map(item => ({
        loadActivityId: item.load_activity_uuid,
        loadCapacity: item.load_capacity,
        lightWeight: item.light_weight,
        loadGrossWeight: item.load_gross_weight,
        tareWeight: item.tare_weight,
        tareFactor: item.tare_factor,
        estimatedLoadCapacity: item.estimated_load_capacity,
        loadNo: item.load_no,
        loadDate: item.load_date,
        loadDateTz: item.load_date_tz,
        crewUuid: item.crew_uuid,
        crewName: item.crew_name,
        operatorUuid: item.operator_uuid,
        operatorName: item.operator_name,
        sourceEquipmentGroupId: item.source_equipment_group_uuid,
        sourceEquipmentGroupName: item.source_equipment_group_name,
        targetEquipmentGroupId: item.target_equipment_group_uuid,
        targetEquipmentGroupName: item.target_equipment_group_name,
        fieldGeoShapeId: item.field_geo_shape_uuid,
        fieldGeoRegionId: item.field_geo_region_uuid,
        fieldGeoRegionName: item.field_geo_region_name,
        fieldGeoShapeName: item.field_geo_shape_name,
        sourceOffloadGeoShapeId: item.source_offload_geo_shape_uuid,
        sourceOffloadGeoRegionName: item.source_offload_geo_region_name,
        sourceOffloadGeoShapeName: item.source_offload_geo_shape_name,
        sourceOffloadStorageLocationId: item.source_offload_geo_storage_location_uuid,
        sourceOffloadStorageLocationName: item.source_offload_geo_storage_location_name,
        sourceOffloadGeoRegionId: item.source_offload_geo_region_uuid,
        sourcePipe: item.sourcePipe,
        sourcePipeId: item.sourcePipeId,
        offloadGeoShapeId: item.offload_geo_shape_uuid,
        offloadGeoRegionName: item.offload_geo_region_name,
        offloadGeoShapeName: item.offload_geo_shape_name,
        offloadStorageLocationId: item.offload_geo_storage_location_uuid,
        offloadStorageLocationName: item.offload_geo_storage_location_name,
        offloadGeoRegionId: item.offload_geo_region_uuid,
        pipe: item.pipe,
        pipeId: item.pipeId,
        targetPlanTypeId: item.target_plan_type_id,
        transportEquipmentGroupId: item.transport_equipment_group_uuid,
        transportEquipmentGroupName: item.transport_equipment_group_name,
        transportOperatorName: item.transport_operator_name,
        transloadGeoRegionId: item.transload_geo_region_uuid,
        transloadGeoRegionName: item.transload_geo_region_name,
        transloadGeoShapeId: item.transload_geo_shape_uuid,
        transloadGeoShapeName: item.transload_geo_shape_name,
        startDateTz: item.start_date_tz,
        endDateTz: item.end_date_tz,
        loadSeconds: item.load_seconds,
        transferType: item.transfer_type,
        anonymousEg: item.anonymous_eg,
        approved: (item.approved > 0),
        lastModifiedAt: item.last_modified_at,
        customerId: item.customer_uuid ? item.customer_uuid : null,
        customerName: item.customer_name ? item.customer_name : null,
        load_params: item.load_params,
        notes: item.notes,
        loadSequence: item.load_sequence ? item.load_sequence : [],
        seed_sample: item.seed_sample,
        seed_piece_profile: item.seed_piece_profile,
        completed: item.completed ? item.completed : false,
        cropName: item.crop_name ? item.crop_name : false,
        modifiedByNameFromQueue: item.modified_by_name_from_queue ? item.modified_by_name_from_queue : null,
        sourceOperatorname: item.source_operator_name ? item.source_operator_name : null,
        sourceFieldId: item.source_field_uuid ? item.source_field_uuid : null,
        sourceFieldName: item.source_field_name ? item.source_field_name : null,
        scaleTicket: item.scale_ticket ? item.scale_ticket : [],
        seedClass: item.seed_class ? item.seed_class : null,
    }));
};

export const parseLoadFromManualForDashboard = loadList =>
    loadList.map(item => ({
        loadActivityId: item.load_activity_uuid,
        loadDate: item.load_date,
        loadCapacity: item.load_capacity,
        tareWeight: item.tare_weight,
        grossWeight: item.load_gross_weight,
        sourceEquipmentGroupId: item.source_equipment_group_uuid,
        sourceEquipmentGroupName: item.source_equipment_group_name,
        targetEquipmentGroupId: item.target_equipment_group_uuid,
        targetEquipmentGroupName: item.target_equipment_group_name,
        transportEquipmentGroupId: item.transport_equipment_group_uuid,
        transportEquipmentGroupName: item.transport_equipment_group_name,
        transportOperatorName: item.transport_operator_name,
        transloadGeoRegionId: item.transload_geo_region_uuid,
        transloadGeoRegionName: item.transload_geo_region_name,
        transloadGeoShapeId: item.transload_geo_shape_uuid,
        transloadGeoShapeName: item.transload_geo_shape_name,
        fieldGeoRegionId: item.field_geo_region_uuid,
        fieldGeoShapeId: item.field_geo_shape_uuid,
        fieldGeoRegionName: item.field_geo_region_name,
        offloadGeoShapeId: item.offload_geo_shape_uuid,
        offloadGeoShapeName: item.offload_geo_shape_name,
        offloadGeoRegionId: item.offload_geo_region_uuid,
        offloadGeoRegionName: item.offload_geo_region_name,
        crewUuid: item.crew_uuid,
        crewName: item.crew_name,
        customerId: item.customer_uuid ? item.customer_uuid : null,
        customerName: item.customer_name ? item.customer_name : null,
        pipe: item.pipe,
        pipeId: item.pipeId,
        notes: item.notes,
        loadSequence: item.load_sequence ? item.load_sequence : [],
        seed_sample: item.seed_sample,
        startDate: item.start_date,
        endDate: item.end_date,
    }));

export const parseLoadQueuePrint = load => {
    return {
        load_activity_uuid: load.loadActivityId,
        load_capacity: load.loadCapacity,
        light_weight: load.lightWeight,
        load_gross_weight: load.loadGrossWeight,
        tare_weight: load.tareWeight,
        tare_factor: load.tareFactor,
        estimated_load_capacity: load.estimatedLoadCapacity,
        load_no: load.loadNo,
        load_date: load.loadDate,
        load_date_tz: load.loadDateTz,
        crew_uuid: load.crewUuid,
        crew_name: load.crewName,
        operator_uuid: load.operatorUuid,
        operator_name: load.operatorName,
        source_equipment_group_uuid: load.sourceEquipmentGroupId,
        source_equipment_group_name: load.sourceEquipmentGroupName,
        target_equipment_group_uuid: load.targetEquipmentGroupId,
        target_equipment_group_name: load.targetEquipmentGroupName,
        field_geo_shape_uuid: load.fieldGeoShapeId,
        field_geo_region_name: load.fieldGeoRegionName,
        field_geo_shape_name: load.fieldGeoShapeName,
        offload_geo_shape_uuid: load.offloadGeoShapeId,
        offload_geo_region_name: load.offloadGeoRegionName,
        offload_geo_shape_name: load.offloadGeoShapeName,
        offload_geo_storage_location_uuid: load.offloadStorageLocationId,
        offload_geo_storage_location_name: load.offloadStorageLocationName,
        offload_geo_region_uuid: load.offloadGeoRegionId,
        pipe: load.pipe,
        pipeId: load.pipeId,
        transport_equipment_group_uuid: load.transportEquipmentGroupId,
        transport_equipment_group_name: load.transportEquipmentGroupName,
        transport_operator_name: load.transportOperatorName,
        transload_geo_region_uuid: load.transloadGeoRegionId,
        transload_geo_region_name: load.transloadGeoRegionName,
        transload_geo_shape_uuid: load.transloadGeoShapeId,
        transload_geo_shape_name: load.transloadGeoShapeName,
        start_date_tz: load.startDateTz,
        end_date_tz: load.endDateTz,
        load_seconds: load.loadSeconds,
        transfer_type: load.transferType,
        anonymous_eg: load.anonymousEg,
        approved: (load.approved > 0),
        last_modified_at: load.lastModifiedAt,
        customer_uuid: load.customerId,
        customer_name: load.customerName,
        completed: load.completed ? load.completed : false,
        crop_name: load.cropName ? load.cropName : false,
        modified_by_name_from_queue: load.modifiedByNameFromQueue ? load.modifiedByNameFromQueue : null,
        source_operator_name: load.sourceOperatorname ? load.sourceOperatorname : null
    }
}
